module.exports = __webpack_public_path__ + "media/hph-25-05_commencement.eaf9fdfe.webm";